
import React, { PropTypes } from 'react';

import Link from 'components/Link';
import UserAvatar from 'components/UserAvatar';
import './style.scss';

const SidebarGroupItem = props => {

  return (
    <div className="SidebarGroupItem">
      <div className="avatar">
        <UserAvatar imageUrl={props.authorAvatarUrl} letter={props.authorName[0]} />
      </div>

      <h5><Link to={props.articleUrl}>{props.title}</Link></h5>
      <p className="author">{props.authorName}</p>
    </div>
  );
};

SidebarGroupItem.propTypes = {
  authorAvatarUrl: PropTypes.string,
  authorName: PropTypes.string,
  articleUrl: PropTypes.string,
  title: PropTypes.string
};

export default SidebarGroupItem;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/index.js
 **/